import React, { useEffect, useState } from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import './QuizzBtn.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import CustomCard from './CustomCard';
import axiosInstance from '../configurations/axiosInstance/AxiosInstance';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faJournalWhills, faListCheck } from '@fortawesome/free-solid-svg-icons';

const QuizzBtn = () => {
  const [showModal, setShowModal] = useState(false);

  const [quizz, setQuizz] = useState(null);

    const fetchQuizz = ()=>{
        axiosInstance().get('public/api/sondage/anonyme')
            .then(function (response) {
                let data = response.data;
                if(data.length===0){
                    setQuizz(null);
                }else {
                    setQuizz(data);
                }
            })
            .catch(function (error) {
                setQuizz(null);
            });

    }
    useEffect(
        ()=>{
            fetchQuizz();
        },[]
    )

  const quizzes = [
    {
        id: 1,
        title: "Transport Maritime",
        description: "Testez vos connaissances sur le transport maritime",
        duration: "10 minutes",
        questions: 15,
        difficulty: "Intermédiaire"
      },
      {
        id: 2,
        title: "Douanes et Réglementations",
        description: "Questions sur les procédures douanières",
        duration: "15 minutes",
        questions: 20,
        difficulty: "Avancé"
      },
      {
        id: 3,
        title: "Logistique Internationale",
        description: "Les bases de la logistique internationale",
        duration: "8 minutes",
        questions: 10,
        difficulty: "Débutant"
      },
      {
        id: 4,
        title: "Transport Maritime",
        description: "Testez vos connaissances sur le transport maritime",
        duration: "10 minutes",
        questions: 15,
        difficulty: "Intermédiaire"
      },
      {
        id: 5,
        title: "Douanes et Réglementations",
        description: "Questions sur les procédures douanières",
        duration: "15 minutes",
        questions: 20,
        difficulty: "Avancé"
      },
      {
        id: 6,
        title: "Logistique Internationale",
        description: "Les bases de la logistique internationale",
        duration: "8 minutes",
        questions: 10,
        difficulty: "Débutant"
      }
  ];

  return (
    <>
    {quizz != null && <>
      <button 
        className="quizz-floating-btn" 
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faListCheck} className='md:mr-2'/>
        <span className="hidden md:inline">Sondages</span> 
      </button>

      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        contentClassName="bg-transparent border-0 shadow-none"
      >
        <div className="relative overflow-hidden bg-white rounded-[2rem] shadow-2xl border border-gray-100">
          {/* Top Decorative Header */}
          <div className="absolute top-0 left-0 right-0 h-40 bg-gradient-to-br from-emerald-500 via-green-600 to-teal-700 rounded-t-[2rem] overflow-hidden">
            <div className="absolute -top-10 -right-20 w-60 h-60 bg-white opacity-20 rounded-full blur-3xl"></div>
            <div className="absolute top-10 -left-10 w-40 h-40 bg-white opacity-10 rounded-full blur-2xl"></div>
          </div>
          
          <button 
            onClick={() => setShowModal(false)}
            className="absolute top-4 right-4 z-20 p-2 text-white/80 hover:text-white bg-black/10 hover:bg-black/20 rounded-full transition-all focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>

          <Modal.Body className="p-0 bg-transparent">
            <div className="relative z-10 pt-10 px-8 pb-6 text-center">
               <div className="w-24 h-24 mx-auto bg-white rounded-full flex items-center justify-center p-2 shadow-xl mb-4 border-4 border-green-50 relative z-10">
                  <div className="w-full h-full bg-green-50 rounded-full flex items-center justify-center text-green-600">
                    <FontAwesomeIcon icon={faListCheck} className="text-4xl text-green-600" />
                  </div>
                </div>
                <h3 className="text-3xl font-extrabold text-gray-800 mb-2">Sondages Disponibles</h3>
                <p className="text-gray-500 max-w-md mx-auto text-sm">Participez à nos enquêtes et donnez-nous votre avis pour nous aider à améliorer nos services.</p>
            </div>

            <div className="p-8 pt-4 bg-gray-50/50 rounded-b-[2rem] max-h-[60vh] overflow-y-auto">
              <div className="quizz-grid">
                {quizz.map(quiz => (
                  <CustomCard 
                    key={quiz.id} 
                    name={quiz.name} 
                    createUser={quiz.createUser}
                    questions={quiz.questions.length}
                    id={quiz.id} />
                ))}
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </>}
    </>
    
  );
};

export default QuizzBtn;